import React from 'react'
import { UserAgent, UserAgentConsumer } from './index'

export interface WithUserAgentProps {
  userAgent: UserAgent
}

function withUserAgent<P>(WrappedComponent: React.ComponentType<P & WithUserAgentProps>) {
  const WithUserAgent: React.SFC<P> = props => (
    <UserAgentConsumer>
      {userAgent => {
        return <WrappedComponent {...props} userAgent={userAgent} />
      }}
    </UserAgentConsumer>
  )
  return WithUserAgent
}

export { withUserAgent }
